import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {LookupsDataService} from '@services/lookups-data.service';
import {ContextService} from '@services/context.service';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {UserSoiCampaignDonationService} from '@services/user-soi-campaign-donation.service';
import {takeUntil} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {Subject} from 'rxjs';
import {SOICampaignModel} from '@app/models/soi-campaigns.model';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';
import {AddressModel} from '@app/models/addresses.model';

@Component({
    selector: 'app-campaign-page-3',
    templateUrl: './page-3-address.component.html',
    styleUrls: ['./page-3-address.component.scss'],
    imports: [
        SharedImports,
        AddressFormCustomComponent
    ]
})

export class Page3AddressComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressMailing = {} as AddressModel;
  incomingAddressBilling = {} as AddressModel;
  isSaving: boolean = false;
  @Input() campaignProfile: UserSOICampaignDonationModel;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignId: number;
  @Input() orgCampaignDetails: SOICampaignModel;
  legal = '';
  private ngUnsubscribe = new Subject();

  constructor(private router: Router, private location: Location, private formBuilder: FormBuilder, private lookupsDataService: LookupsDataService,
              public contextService: ContextService, private userSoiCampaignDonationService: UserSoiCampaignDonationService,
              private messageService: MessageService, private changeDetection: ChangeDetectorRef,) {
    this.mainForm = this.formBuilder.group({
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      agree: new FormControl(null, [Validators.required]),
      useMailing: new FormControl(null)
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    // console.log(this.orgCampaignDetails);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.campaignProfile.PaymentMethod) {
      this.mainForm.get('address').setValue(this.campaignProfile.PaymentMethod.Address1);
      this.mainForm.get('address2').setValue(this.campaignProfile.PaymentMethod.Address2);
      this.mainForm.get('city').setValue(this.campaignProfile.PaymentMethod.City);
      this.mainForm.get('state').setValue(this.campaignProfile.PaymentMethod.StateProvinceID);
      this.setStateId = this.campaignProfile.PaymentMethod.StateProvinceID;
      this.mainForm.get('zipCode').setValue(this.campaignProfile.PaymentMethod.Zip);
      const tempAddress = {} as AddressModel;
      tempAddress.Address1 = this.campaignProfile.PaymentMethod.Address1;
      tempAddress.Address2 = this.campaignProfile.PaymentMethod.Address2;
      tempAddress.City = this.campaignProfile.PaymentMethod.City;
      tempAddress.StateProvinceID = this.campaignProfile.PaymentMethod.StateProvinceID;
      tempAddress.Zip = this.campaignProfile.PaymentMethod.Zip;
      this.incomingAddressBilling = tempAddress;
      // console.log(this.incomingAddressBilling);
    }

    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      //this.campaignProfile.PaymentMethod = {} as PaymentMethodModel;
      this.campaignProfile.PaymentMethod.Address1 = this.mainForm.get('address').value;
      this.campaignProfile.PaymentMethod.Address2 = this.mainForm.get('address2').value;
      this.campaignProfile.PaymentMethod.City = this.mainForm.get('city').value;
      this.campaignProfile.PaymentMethod.StateProvinceID = this.mainForm.get('state').value;
      this.campaignProfile.PaymentMethod.Zip = this.mainForm.get('zipCode').value;
      this.updateData.emit(this.campaignProfile);
    });
    this.mainForm.get('useMailing').valueChanges.subscribe(value => {
      // console.log(value);
      if (value === true) {
        // console.log('in here');
        const tempAddress = {} as AddressModel;
        this.incomingAddressBilling = null;
        this.changeDetection.detectChanges();
        this.mainForm.get('address').setValue(this.campaignProfile.Address1);
        this.mainForm.get('address2').setValue(this.campaignProfile.Address2);
        this.mainForm.get('city').setValue(this.campaignProfile.City);
        this.mainForm.get('state').setValue(this.campaignProfile.StateProvinceID);
        this.mainForm.get('zipCode').setValue(this.campaignProfile.Zip);
        tempAddress.Zip = this.campaignProfile.Zip;
        tempAddress.Address1 = this.campaignProfile.Address1;
        tempAddress.Address2 = this.campaignProfile.Address2;
        tempAddress.City = this.campaignProfile.City;
        tempAddress.StateProvinceID = this.campaignProfile.StateProvinceID;
        this.incomingAddressBilling = tempAddress;
        // console.log(this.incomingAddressBilling);
        this.changeDetection.detectChanges();
        this.setStateId = this.campaignProfile.StateProvinceID;
      } else {
        this.mainForm.get('address').setValue(null);
        this.mainForm.get('address2').setValue(null);
        this.mainForm.get('city').setValue(null);
        this.mainForm.get('state').setValue(null);
        this.mainForm.get('zipCode').setValue(null);
        this.setStateId = null;
      }
    });
  }

  goToNextPage() {
    this.processData();
  }

  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      // console.log(addressChanges);
      this.mainForm.markAsDirty();
      //this.campaignProfile.CountryID = 1;
      this.campaignProfile.PaymentMethod.Address1 = addressChanges.Address1;
      this.campaignProfile.PaymentMethod.Address2 = addressChanges.Address2;
      this.campaignProfile.PaymentMethod.City = addressChanges.City;
      this.campaignProfile.PaymentMethod.StateProvinceID = addressChanges.StateProvinceID;
      this.campaignProfile.PaymentMethod.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);
      this.updateData.emit(this.campaignProfile);
    }
  }

  processData() {
    this.isSaving = true;
    this.saveData();
  }

  saveData() {
    this.userSoiCampaignDonationService.submitSOICampaignDonation(this.orgCampaignDetails.ID, this.campaignProfile)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Your Donation has been processed successfully'});
          this.next.emit();
          this.isSaving = false;
        }, error: (e) => {
          if (e?.error?.Message) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: e.error.Message.replace('UM: ', ''), life: 5000});
          } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Our apologies... An error occurred. Please try again and let us know if it continues. Thank you!'});
          }
          this.isSaving = false;
        }
      });
  }
}
